import React, { useState, useEffect } from 'react';

// Components
import WpChoice from '../choice/WpChoice';

export interface Props {
  /** ID for the input */
  id: string;
  /** value for the input */
  value?: string;
  /** Name for form input */
  name?: string;
  /** Additional hint text to display */
  descriptionText?: string;
  /** checkbox is selected */
  checked?: boolean;
  /** Label for the input */
  label: string;
  /** Disable the input */
  disabled?: boolean;
  /** Automatically focus the input */
  autoFocus?: boolean;
  /** Callback when value is changed */
  onChange?(checked: boolean): void;
  /** component used to replace label if included */
  component?: React.ReactNode;
  /** hide label of checkbox */
  labelHidden?: boolean;
  stopPropagation?: boolean;
}

const WpCheckbox: React.FC<Props> = ({
  id,
  value,
  name,
  descriptionText,
  label,
  checked = false,
  autoFocus,
  disabled,
  onChange,
  component,
  labelHidden = false,
  stopPropagation = false,
}: Props) => {
  const [isChecked, setIsChecked] = useState(false);
  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked);
    if (onChange) onChange(event.target.checked);
  };

  const handleOnClick = e => {
    if (stopPropagation) {
      e.stopPropagation();
    }
  };

  const baseClassName = 'WpCheckbox';

  const checkbox = (
    <div className={baseClassName}>
      <input
        id={id}
        name={name}
        value={value}
        type="checkbox"
        checked={isChecked}
        disabled={disabled}
        onChange={handleChange}
        autoFocus={autoFocus}
        onClick={handleOnClick}
      />
    </div>
  );

  return (
    <>
      {labelHidden ? (
        <>{checkbox}</>
      ) : (
        <WpChoice
          id={id}
          label={label}
          descriptionText={descriptionText}
          onClick={() => handleChange}
          component={component}
        >
          {checkbox}
        </WpChoice>
      )}
    </>
  );
};

export default WpCheckbox;
